import { ApiResponse, Route } from '../types/api';
import { http } from './http'

export interface Segment {
  fromStationId: number
  toStationId: number
  polyline: { lat: number; lng: number }[]
  totalDist: number
}



// ✅ ดึงทั้งหมด
export const listSegments = async (): Promise<Segment[]> => {
  const { data } = await http.get<ApiResponse<Segment[]>>('/app/segments')
  if (!data.success || !data.data) {
    throw new Error(data.error || 'โหลดเส้นทางไม่สำเร็จ')
  }
  return data.data
}

export const listRoutes = async () : Promise<Route[]> => {
  const { data } = await http.get<ApiResponse<Route[]>>('/routes')
  if (!data.success || !data.data) {
    throw new Error(data.error)
  }
  return data.data
}

export const getRoute = async (id : number) : Promise<Route> => {
    const { data } = await http.get<ApiResponse<Route>>(`/routes/${id}`);
    if (!data.success || !data.data) throw new Error(data.error || "Load Route failed");
    return data.data;
}

export const createRoute = async (payload: {
  name: string
  segments: Segment[]
}): Promise<Route> => {
  const { data } = await http.post<ApiResponse<Route>>('/routes', payload)
  if (!data.success || !data.data) {
    throw new Error(data.error || 'สร้างเส้นทางไม่สำเร็จ')
  }
  return data.data
}

export const updateRoute = async (
  id: number,
  payload: {
    name: string
    segments: Segment[]
  }
): Promise<Route> => {
  const { data } = await http.put<ApiResponse<Route>>(`/routes/${id}`, payload)
  if (!data.success || !data.data) {
    throw new Error(data.error || 'อัปเดตเส้นทางไม่สำเร็จ')
  }
  return data.data
}